<template>
<!--内容列表-->
  <div id="contenList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <!--            <span>ID</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" placeholder="ID" type="number" v-model="postData.ID"> -->
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标题" type="text" v-model="postData.title">
          </p>
          <p>
            <!--            <span>名称</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" placeholder="名称" type="text" v-model="postData.title"> -->
            <input @keyup.enter="getList(1)" class="allInput" placeholder="标签" type="text" v-model="postData.tags">
          </p>
          <!--          <p>-->
          <!--            <input @keyup.enter="getList(1)" class="allInput" placeholder="tag" type="text" v-model="postData.tag">-->
          <!--          </p>-->
          <p>
            <!--            <span>内容分类</span>-->
            <abbr class="d_i">
              <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="postData.categoryId">
              </allSelect>
            </abbr>
          </p>
<!--          <p>-->
<!--            <input @keyup.enter="getList(1)" class="allInput" placeholder="tag" type="text" v-model="postData.tag">-->
<!--          </p>-->
          <!-- <p> -->
<!--            <span>内容分类</span>-->
            <!-- <abbr class="d_i">
              <allSelect :chooseData="allcontent" :needReturn="'id'" :placeholder="'请选择内容分类（可多选）'" :matchValue="'typeName'" :showValue="'{{typeName}}'" :multiple="true" v-model="postData.ContentTypeIds">
              </allSelect>
            </abbr>
          </p> -->
<!--          <p v-if="onSearch"><span>创建人</span>-->
<!--            <input class="allInput" type="text" v-model="postData.name">-->
<!--          </p>-->
          <!-- <p v-if="onSearch"> -->
<!--            <span class="d_i">更新时间</span>-->
            <!-- <cander v-model="postData.startdate" :className="'allInput'" placeholderName="更新开始时间"  class="d_i" style="vertical-align: middle"></cander>
            <abbr class="d_i">-</abbr>
            <cander :minDate="postData.startdate" v-model="postData.enddate" :className="'allInput'" placeholderName="更新结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p> -->
          <button @click="getList(1)" class="redButton">搜索</button>
        </div>
        <div style="width: auto">
          <!-- <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span> -->
          <!-- <button @click="clearModel()" class="cancelButtonTwo m_r_10">清空</button> -->
          <!-- <button class="redButtonTwo" @click="ImportNewTag">标签更新</button> -->
          <button class="redButtonTwo" @click="editToUrl()" >新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <!-- <nav class="t_r m_b_10"><button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('ContentEditor') >= 0">新建</button></nav> -->
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>ID</th>
            <th>标题</th>
            <th>文章类型</th>
            <th>分类</th>
            <th>标签</th>
            <th>更新时间</th>
            <th>创建人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td width="10%">{{totalCount - ((index + 1) + (10 * (postData.PageIndex - 1))) + 1}}</td>
            <td width="20%" class="NoWrap" style="max-width: 200px" :title="item.title">{{item.title}}</td>
            <td width="10%">{{item.articleType == 'F' ? '武田推文' : '腾讯推文'}}</td>
            <td width="10%">{{item.categoryName}}</td>
            <td width="20%" class="NoWrap" style="max-width: 200px" :title="item.tags">{{item.tags}}</td>
            <td width="10%">{{item.lastModificationTime ? $commonJs.returnNewDate(item.lastModificationTime) : ''}}</td>
            <td width="10%" style="max-width: 100px" class="t_c NoWrap" :title="item.createUserName">{{item.createName}}</td>
            <td width="10%"><div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li @click="viewList(item)">查看</li>
                <li @click="editList(item)" >编辑</li>
                <li @click="deleteDraft(item)" >删除</li>
              </ul>
            </div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!--内容列表-新建内容-->
    <model v-if="newModel" :buttonType="0" :title="'新建草稿'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div class="t_c" style="margin-top: 30px;margin-bottom: 20px;height: 200px">
        <span><i class="colorRed m_r_5">*</i><abbr>内容分类：</abbr></span>
        <abbr style="display: inline-block;width: 350px">
          <allSelect :width="350" :chooseData="allcontent2" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="addnewContentType">
          </allSelect>
        </abbr>
      </div>
    </model>
    <!-- 导入标签 -->
    <model v-if="showModelImport" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelTagModel()" v-on:on-confirm="confirModelImport()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>请上传文件</span>
            <input @change="uploadTagimportfile($event)" type="file" id="file" multiple>
          </li>
        </ul>
      </div>
    </model>
    <contentPreview :contentId="previewContentId" v-model="coverShow"></contentPreview>
  </div>
</template>

<script>
import contentPreview from '../../myComponents/contentPreview'
export default {
  name: 'contenList',
  data () {
    return {
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      previewContentId: 0,
      addnewContentType: '',
      FilePD: 'False',
      onSearch: false,
      coverShow: false,
      showModelImport:false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        ID: '',
        title: '',
        status: 1,
        categoryId: '',
        tags: '',
        ContentTypeIds: '',
        startdate: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      allcontent: JSON.parse(window.sessionStorage.getItem('allContentType')),
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || [{id: 1, typeName: '测试类别'}],
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }]
    }
  },
  created () {
    const oldarrs = this.allcontent2
    let newarrs = []
    oldarrs.forEach(res=>{
      if((res.name).indexOf('历史打标文章')<0&&(res.productName).indexOf('[PDT&CM]CM')<0  &&
       // add by clh@20260206
      // 隐藏所有产品组为MarketingHCP以及【CM】县域的分类
      // 除MED产品组外，其余的产品组均只保留新文章分类，其余分类隐藏，如当前没有新文章分类，则修改分类名称为新文章
      // 隐藏[MED]Rurioctocog alfa pegol 产品组下分类
      res.productName.indexOf('【CM】县域') < 0 &&
      res.productName.indexOf('MarketingHCP') < 0 &&
      res.productName.indexOf('[MED]Rurioctocog alfa pegol') < 0 &&
      (res.productName === '【MED】Medical' || res.name === '新文章')
    ){
        
        newarrs.push(res)
      }
    })
    this.allcontent2 = newarrs

    
    this.searchCate = this.searchCate.concat(this.allcontent2)
    // this.getconTypeList()
    // this.getconTypeList2()
    this.getList(1)
  },
  methods: {
    clearModel () {
      this.postData = {
        ID: '',
        title: '',
        status: 1,
        ContentTypeIds: '',
        startdate: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      }
    },
    // getconTypeList () {
    //   this.$axiox.get('/api/contentType/fromuser/' + JSON.parse(this.userInfo.id)).then(msg => {
    //     let editorTypes = JSON.parse(JSON.stringify(msg.result.editorTypes))
    //     let ownerTypes = JSON.parse(JSON.stringify(msg.result.ownerTypes))
    //     this.allcontent2 = this.$commonJs.distinct(editorTypes, ownerTypes)
    //     console.log(this.allcontent2)
    //   })
    // },
    // getconTypeList2 () {
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    deleteDraft (object) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此草稿？',
        successFun: msg => {
          this.$axiox.del('/api/Article/' + object.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    viewList (object) {
      this.previewContentId = object.id
      this.coverShow = true
    },
    ImportNewTag () {
      this.modelTitle = '导入标签'
      this.showModelImport = true
    },
    cencelPreview () {
      this.coverShow = false
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
      // this.$router.push({
      //   path: 'editContList',
      //   query:{id: 0}
      // })
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/Article', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
      console.log(this.postData)
    },
    editList (item) {
      this.$router.push({
        name: 'editContList',
        query: {
          id: item.id,
          fromType: 'draft',
          selectContentType: item.categoryId,
          selectContentName: item.contentType
        }
      })
    },
    confirModel () {
      if (this.addnewContentType !== '') {
        let selectContentName = this.allcontent2.find(p => { return parseInt(p.id) === parseInt(this.addnewContentType) })
        this.$router.push({
          name: 'editContList',
          query: {
            id: 0,
            fromType: 'draft',
            selectContentType: this.addnewContentType,
            selectContentName: selectContentName.name
          }
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择内容类别!',
          stayTime: 5
        })
      }
    },
    confirModelImport () {
      if(this.FilePD=='False'){
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败！',
            content: '请上传附件！',
            stayTime: 5
          })
          return;
      }
      this.$axiox.get(`/api/Article/AddArticleupdateTagImport`).then(res => {
      if(res=='Suc'){
        this.$commonJs.alertTips({
            type: 'success',
            title: '成功！',
            content: '导入成功！',
            stayTime: 5
          })
      }else{
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res,
            stayTime: 5
          })
      }
      this.showModelImport = false
      this.getList(1)
      this.FilePD='False'
      })
    },
    uploadTagimportfile(e){
      var file = e.target.files[0]
      this.TagUpload(file)
      this.FilePD='True'
      //e.target.value = '' // 防止第二次上传相同的文件不执行 //document.getElementById('file').value = ''
    },
    async TagUpload (e) {
      let fileImg = e
      await this.$commonJs.uploadFile3(fileImg, '/api/RotationChart/AddArticleTagFile')
    },
    cancelModel () {
      this.addnewContentType = ''
      this.newModel = false
    },
    cancelTagModel () {
      this.showModelImport = false
    }
  },
  components: {
    'contentPreview': contentPreview
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/contenList.vue